import React, { useState, useEffect } from 'react';

const TourPopover = ({ step, targetRef, onNext, onComplete, onSkip }) => {
  const [coords, setCoords] = useState(null);
  console.log('[Tour debug] TourPopover rendering for step:', step, 'targetRef.current:', targetRef?.current);

  useEffect(() => {
    const updateCoords = () => {
      if (targetRef?.current) {
        const rect = targetRef.current.getBoundingClientRect();
        setCoords({
          top: rect.top,
          left: rect.left,
          width: rect.width,
          height: rect.height,
          bottom: rect.bottom,
          right: rect.right
        });
      } else {
        console.log('[Tour debug] updateCoords - targetRef.current is null for step:', step);
      }
    };
    updateCoords();
    window.addEventListener('resize', updateCoords);
    window.addEventListener('scroll', updateCoords);
    const timer = setInterval(updateCoords, 100);
    return () => {
      window.removeEventListener('resize', updateCoords);
      window.removeEventListener('scroll', updateCoords);
      clearInterval(timer);
    };
  }, [targetRef, step]);

  if (!coords) return null;

  let message = "";
  if (step === 1) {
    message = "🌟 Your next opportunity starts here. Grab your tailored resume packages and apply with resumes crafted to help you stand out from the crowd.";
  } else if (step === 2) {
    message = "🎯 Manage your job search in one click. I'll help you track applications, interviews, and status updates so nothing slips through the cracks.";
  } else if (step === 3) {
    message = "🌟 Your History Tracker is ready! Manage your resumes and track every application's status from Applied to Offer or Rejected, all in one place.";
  }

  const isBelow = step === 3;

  const cardWidth = typeof window !== 'undefined' ? (window.innerWidth <= 480 ? 260 : (window.innerWidth <= 640 ? 280 : 320)) : 320;
  const halfWidth = cardWidth / 2;
  let centerLeft = coords.left + coords.width / 2;
  const padding = 16;
  if (typeof window !== 'undefined') {
    if (centerLeft - halfWidth < padding) {
      centerLeft = halfWidth + padding;
    } else if (centerLeft + halfWidth > window.innerWidth - padding) {
      centerLeft = window.innerWidth - halfWidth - padding;
    }
  }

  return (
    <div
      className={`tour-popover-card step-${step}`}
      style={{
        position: 'fixed',
        top: isBelow ? `${coords.bottom + 12}px` : `${coords.top - 12}px`,
        left: `${centerLeft}px`,
        transform: isBelow ? 'translate(-50%, 0)' : 'translate(-50%, -100%)',
        zIndex: 10002,
      }}
    >
      <div className="tour-popover-content">
        <div className="tour-popover-body">
          <p className="tour-popover-message">{message}</p>
        </div>
        <div className="tour-popover-footer">
          <div className="tour-popover-left-group">
            <div className="tour-popover-dots">
              <span className={step === 1 ? 'dot active' : 'dot'} />
              <span className={step === 2 ? 'dot active' : 'dot'} />
              <span className={step === 3 ? 'dot active' : 'dot'} />
            </div>
            {step !== 3 && (
              <button className="tour-popover-skip" onClick={onSkip}>
                Skip
              </button>
            )}
          </div>
          {step === 1 && (
            <button className="tour-popover-btn" onClick={onNext}>
              Next &rarr;
            </button>
          )}
          {step === 2 && (
            <span className="tour-popover-hint">Click save to continue!</span>
          )}
          {step === 3 && (
            <button className="tour-popover-btn-success" onClick={onComplete}>
              Awesome, got it!
            </button>
          )}
        </div>
      </div>
      <div className={`tour-popover-arrow step-${step}`} />
    </div>
  );
};

export default TourPopover;
